module.exports = __webpack_public_path__ + "img/logo3.b939e873.png";